import { Cargo } from "./cargo.model";
import {Candidatura} from "./candidatura.model";
export class PreCandidatoCsvDTO {
    constructor(
        public email?: string, 
        public nome?: string,
        public cargo?: Cargo,
        public cargoId?: number,
        public curriculum?: string,
        public cpf?: string,
        public candidatura?: Candidatura,
        public parametroJustificativa?: string,
        public votoJustificavel?: boolean,
        public login?: string,
        public formularioPreenchido?: boolean,
    ) {

    }
}

